export default __webpack_public_path__ + "static/magento_service_features-150d7c547b0e594e0625697749f96882.svg";